import type { IndirectThunkEntry } from '../IndirectThunks';
import orderThunks from './Order';

const thunks: IndirectThunkEntry[] = [...orderThunks];

export default thunks;
